import { useAuth0 } from "@auth0/auth0-react";

export function SignInButton() {
  const { loginWithRedirect } = useAuth0();
  return (
    <button
      className="auth-btn"
      // prompt: "login" forces Auth0 to show the login screen instead of
      // silently re-using an existing SSO session, so users can switch accounts.
      onClick={() => loginWithRedirect({ authorizationParams: { prompt: "login" } })}
    >
      <i className="ti ti-login" aria-hidden="true" />
      Sign in
    </button>
  );
}
